import gql from 'graphql-tag';
import { FARM_FRAGMENT } from './farm';

export const OFFER_FRAGMENT = gql`
  fragment OfferFragment on Offer {
    id
    clusterId
    characteristicsData {
      dataValues {
        name
        dataValue
      }
    }
    code
    webUserId
    skippedDataPulls
    logrocketSessionURL
    purchaseLinkSentTimestamp
    purchaseLinkSentBy
    purchaseLink
    initialCreationDateTime
    inheritedInitialCreationDateTime
    updatedDateTime
    usingNonVerifiedData
    parentId
    skipUnderwritingUntil
    branchPlusOffers {
      id
      bridgeUrl
      carrierName
      carrierId
      monthly
      policyType
      premium
      provider
      status
      message
      sessionId
    }
    rejections {
      type
      value
      data
      level
    }
    quote {
      fname
      lname
      email
      phone
      forcedMultiPolicyDiscount
      attachedHomeowners
      attachedRenters
      attachedAuto
      attachedCondo
      optIntoMarketingCampaigns
      entity {
        id
        type
        name
        address {
          address
          address2
          city
          state
          zip
        }
      }
      monthsAtCurrentAddress
      additionalPhoneNumbers {
        phoneNumber
        note
        canText
      }
      interestedParties {
        id
        name
        email
        relationship
        lossPayee
        associatedEntities
        address {
          address
          address2
          unit
          country
          city
          state
          zip
        }
        loanNumber
        VIN
      }
      farm  {
        mortgageDetails {
          loanNumber
          mortgageHolderName
          mortgageHolderAddress {
            address
            address2
            country
            city
            state
            zip
          }
          mortgageHolderEmail
          mortgageHolderFax
          primary
          isCustom
        }
      }
      farmCoverage {
        identityFraudLimit
        extraExpenseLimit
        propertyInTransitLimit
        hasEquipmentBreakdownCoverage
        propertyInCareIncreasedLimit
        fungiPropertyLimit
        fungiLiabilityLimit
        pollutantCleanupLimit
        pollutantCleanupDeductible
        machineryNotDescribedLimit
        newlyAcquiredMachineryLimit
        rentedOrBorrowedEquipmentLimit
        replacementMachineryLimit
        policyLevelAdjustmentFactor
        adjustmentRationale
        includePersonalUmbrella
        personalUmbrella {
          hasCfmAuto
          limitOfLiability
          selfInsuredRetention
          combinedSingleLimit
          excludeNamedPremises
          excludedPremises {
            address
            address2
            unit
            city
            county
            state
            zip
          }
          primaryAutomobile
          primaryAutomobileYear
          primaryAutomobileMake
          primaryAutomobileModel
          primaryAutoLiabilityLimit
          additionalAutomobiles {
            id
            year
            make
            model
          }
          numAdditionalAutomobiles
          additionalAutoLiabilityLimit
          excludeNamedAutomobile
          excludedAutomobileDescription
          youthfulDrivers {
            id
            name
            dob
            licenseNumber
            licenseState
          }
          excludeNamedDriver
          excludedDriverName
          excludedDriverDob
          antiqueClassicVehicles {
            id
            year
            make
            model
          }
          numIndividualsCaredFor
          dayCareDescription
          dayCareLocation
          hasSwimmingPool
          hasTrampoline
          additionalOwnerOccupiedResidences {
            id
            combinedSingleLimit
            addressDetails {
              address
              address2
              unit
              city
              county
              state
              zip
            }
          }
          rentalDwellings {
            id
            combinedSingleLimit
            addressDetails {
              address
              address2
              unit
              city
              county
              state
              zip
            }
          }
          hasBusinessPursuits
          businessPursuitsDescription
          businessPursuitsLocation
          businessPursuitsLimit
          watercraft {
            id
            category
            description
            horsepowerBand
            lengthBand
            speedBand
          }
          recreationalVehicles {
            id
            category
            description
            horsepower
          }
          excludeCanine
        }
      }
      lienHolders {
        id
        name
        relationship
        lossPayee
        address {
          address
          address2
          unit
          country
          city
          state
          zip
        }
        loanNumber
        VIN
      }
      inviter {
        id
        firstName
        lastName
      }
      selectedOption
      fromStaff
      originallyFrom
      simulationConfig {
        source
        noHitDataPulls
      }
      rep
      isAgentSold
      leadSource
      noBindHome
      noBindAuto
      isBix
      includeUmbrella
      includeRenters
      includeEarthquake
      includeFlood
      existingCustomer {
        id
      }
      offerings {
        autoRejectCode
        monolineAutoRejectCode
        monolineHomeRejectCode
        monolineCondoRejectCode
        homeownersRejectCode
        condoRejectCode
        rentersRejectCode
        offerAuto
        offerUmbrella
        offerRenters
        offerCondo
        offerHomeowners
        offerWaterBackup
      }
      correctedAddress {
        address
        address2
        city
        state
        zip
      }
      priorAddress {
        address
        address2
        unit
        city
        state
        zip
      }
      connectedHome {
        monitored
        moistureDevices
        theftPreventionDevices
        motionDetectingDevices
        smokeDetectingDevices
        autoWaterShutoffDevices
        providerName
        agreeToTerms
      }
      auto {
        hasSetPip,
        pipResidentsConfirmation,
        pipEligibilityConfirmation
        householdMembers
        pipResidentsWithQHC
        pipExcludedResidents
        pipAllResidents
        pipEveryoneOnSamePlan
        pipHealthInsuranceType
        pipAdditionalResidents
        residenceInsuranceType
        companionPolicyType
        companionPolicyNumber
        primaryResidentHomeowner
        adjustmentFactor
        adjustmentRationale
      }
      home {
        basementType
        basementSqFt
        originalBasementSqFt
        constructionType
        county
        exteriorWallType
        garageCarCapacity
        garageType
        homeQuality
        numFamiliesInDwelling
        numFireplaces
        numFullBathrooms
        numHalfBathrooms
        numOccupants
        numStories
        numWoodBurningStoves
        ownershipStatus
        purchaseDate
        purchaseAmount
        roofShape
        roofType
        roofYear
        roofReplacementYearMax
        roofYearChangedManually
        roofDeck
        roofCover
        roofDeckAttachment
        roofToWallConnection
        openingProtection
        roofSWR
        sqFt
        originalSqFt
        typeOfHome
        yearBuilt
        latitude
        longitude
        fireHydrantWithin1000ft
        porchCode
        porchSqFt
        hasTrampoline
        constructionStyle
        areasUnderConstruction
        fpc
        fpcFromLocation
        fpcOverride
        fpcOverrideValue
        fpcOverrideReason
        fpcOverrideBy
        swimmingPool
        roofOriginal
        wildfireHazardScore
        wildfireGallagherScore
        dtoName
        dtbowName
        dtbowLabel
        windstormMitigationLevel
        stormShutters
        fortifiedHome
        capeConditions {
          roofCondition
          roofConditionConfidence
          hasRoofSolarPanels
          yardDebrisSqFt
          yardDebrisConfidence
          trampolinePresence
          roofAgeImage
          roofConditionImage
        }
        homeLocation {
          address
          address2
          city
          state
          zip
        }
        replacementCostEstimate {
          total
          itemized {
            calculatedValue
            type
            desc
            id
          }
          valuationId
        }
        mortgageDetails {
          loanNumber
          mortgageHolderName
          mortgageHolderAddress {
            address
            address2
            country
            city
            state
            zip
          }
          mortgageHolderEmail
          mortgageHolderFax
          primary
          isCustom
        }
      }
      condo {
        constructionType
        condoLocation {
          address
          address2
          city
          state
          zip
        }
        condoQuality
        mortgageDetails {
          loanNumber
          mortgageHolderName
          mortgageHolderAddress {
            address
            address2
            country
            city
            state
            zip
          }
          mortgageHolderEmail
          mortgageHolderFax
          primary
          isCustom
        }
        numFullBathrooms
        numHalfBathrooms
        numOccupants
        ownershipStatus
        purchaseDate
        purchaseAmount
        replacementCostEstimate {
          total
          itemized {
            calculatedValue
            type
            desc
            id
          }
          valuationId
        }
        roofShape
        sqFt
        typeOfCondo
        typeOfEntry
        hasBasement
        buildingHasMoreThanFiveUnits
        yearBuilt
        latitude
        longitude
        fpc
        county
        fireHydrantWithin1000ft
        windstormMitigationLevel
        fpcFromLocation
        fpcOverride
        fpcOverrideValue
        fpcOverrideReason
        fpcOverrideBy
        floor
        weeksRentedOut
        hasUnitNumber
        floor
        numVehicles
        dtoName
        dtbowName
        dtbowLabel
        wildfireHazardScore
        wildfireGallagherScore
      }
      cars {
        addDate
        VIN
        year
        make
        model
        bodyType
        assignedDriver
        userAssignedDriver
        primaryUse
        purchaseDate
        deductibleCollision
        deductibleComprehensive
        coverageLoan
        limitUMPD
        limitRental
        limitACPE
        customEquipmentDescription
        limitIncomeLoss
        roadsideAssistance
        extendedNonOwnedCoverage
        solelyOwnedByApplicant
        jointOwner
        jointOwnerName
        jointOwnerAddress {
          address
          address2
          city
          state
          zip
        }
        jointOwnerSameHousehold
        jointOwnerRelated
        jointOwnerRelationship
        rideSharing
        umuimRejected
        aebStatus
        aebConfirmed
        antiTheftStatus
        antiTheftConfirmed
        blindSpotStatus
        blindSpotConfirmed
        singleAirbagStatus
        singleAirbagConfirmed
        doubleAirbagStatus
        doubleAirbagConfirmed
        luxury
        lastSevereIncidentDate
        annualMilesDriven
        hasOutstandingRecall
        brandedTitle
        brandedTitleDescription
        garageLocation {
          address
          country
          city
          state
          zip
        }
        isGarageAddressRuleExceptionApproved
        symbolMake
        symbolModel
        symbolStyle
        symbolAux
        symbolPGS
        symbolBI
        symbolPD
        symbolMed
        symbolPIP
        symbolColl
        symbolComp
        symbolUM
        vehicleTypeCode
        vehicleHorsepowerCode
        convertible
        vehicleSymbolGroup
        rapaLiabilitySymbol1
        rapaLiabilitySymbol2
        rapaPhysDamSymbol1
        rapaPhysDamSymbol2
      }
      trailers {
        VIN
        type
        primaryUse
        year
        value
        contents
        purchaseDate
        deductibleCollision
        deductibleComprehensive
        garageLocation {
          address
          country
          city
          state
          zip
        }
        confirmed
        coverageLoan
        addDate
      }
      autoCoverage {
        policyLimitBIPD
        policyLimitUMBI
        policyLimitUIMBI
        policyLimitMedicalPayments
        policyLimitUMPD
        policyLimitPIP
        policyLimitLPD
        petInjury
        coverageEducatorAdvantage
        coverageOffPremisesExpanded
        policyLimitPIPME
        policyLimitPIPWL
        policyLimitPIPACR
        policyLimitIncomeLoss
        policyLimitAccidentalDeath
        policyLimitFuneralBenefits
        policyLimitExtraMedBenefits
        policyLimitTortOption
        policyLimitComboFBP
        policyLimitGuestPIP
        policyLimitNoFaultPIP
        uimAddedOn
      }
      homeCoverage {
        coverageA
        limitOverride
        limitOverrideReason
        limitOverrideBy
        limitOverrideAt
        limitOverrideRemovedBy
        limitOverrideRemovedAt
        coverageIBSC
        coverageBPctOfA
        coverageBCPctOfA
        coverageCPctOfA
        coverageDPctOfA
        coverageX
        coverageY
        coverageMS
        coverageMSALE
        coverageWaterBackup
        coverageBuildingMaterialsTheft
        coverageCourseOfConstruction
        coverageExtendedPremises
        coverageEducatorAdvantage
        coverageOffPremisesExpanded
        coverageFairRental
        coveragePetBite
        coverageRSExtended
        coverageYardAndGarden
        coverageSinkhole
        coverageOilStorageTank
        coverageBP
        coverageCA
        coverageDC
        coverageDR
        coverageF
        coverageG
        coverageJ
        coverageMI
        coverageSP
        coverageST
        coverageEBSL
        coverageFortifiedRoof
        homeownerProtection
        deductibleAllOther
        deductibleHurricane
        deductibleWindHail
        deductibleWaterBackup
        windHailExclusion
        minimumDeductibleValue
        minimumWindHailDeductible
        minimumWindHailDeductibleValue
        minimumHurricaneDeductible
        minimumHurricaneDeductibleValue
        interestedInSeparateWindHail
        externalPolicyId
      }
      condoCoverage {
        coverageC
        coverageA
        coverageBCPctOfC
        coverageDPctOfC
        coverageEBSL
        coverageX
        coverageY
        coverageF
        coverageJ
        coverageMI
        coverageBP
        coverageCA
        coverageSP
        coverageST
        coverageDR
        coverageIBSC
        coveragePetBite
        minimumDeductibleValue
        personalPropReimbursement
        coverageG
        coverageWaterBackup
        coverageMSALE
        coverageMS
        deductibleAllOther
      }
      homeViolations {
        AAF
        CMP
        D
        E
        F
        G
        MAJ
        MIN
        NAF
      }
      homeClaimsForUW {
        amount
        lossTypeCode
        lossDate
        claimGroup
        addresses {
          address
          city
          state
          zip
        }
        subjects {
          firstName
          lastName
          type
        }
        matchReason {
          code
          description
        }
      }
      homeClaimDates
      homeViolationPeople
      homeViolationDates
      homeSingleViolationDates
      nonDrivers {
        id
        firstName
        lastName
        dateOfBirth
        pipEligible
        pipOptOut
        pipHasQHC
        waivedPIPWL
        age
      }
      drivers {
        id
        pipEligible
        waivedPIPWL
        pipOptOut
        pipHasQHC
        postBindMVR
        addDate
        assignedCar
        userAssignedCar
        autoViolationDates
        communityDriveParticipation
        isPrimary
        isCoApplicant
        firstName
        middleName
        lastName
        suffix
        gender
        maritalStatus
        highestEducation
        driverStatus
        age
        dateOfBirth
        driversLicenseState
        driversLicenseNumber
        skipLicenseNumValidation
        ageFirstLicensed
        relationshipToInsured
        fullTimeStudent
        goodStudent
        takenCourse
        courseDiscountConditionCheck
        # CFM auto Claims Free / Violation Free discounts (#35626); derived server-side, read-only.
        autoClaimsFree
        autoViolationFree
        excludeDriver
        schoolName
        schoolZip
        needSR22
        lapsedLicense
        exclusionReason
        hasViolationsBlockingUmbrella
        hasMajorViolationBlockingUmbrella
        hasAtFaultAccidentBlockingUmbrella
        schoolLocation {
          address
          address2
          country
          city
          state
          zip
        }
        insuranceScore {
          homeTotal
          autoTotal
          total
        }
        insuranceScoreOverride
        insuranceScoreOverrideValue
        autoViolationsForUW {
          AAF
          AFM
          ANC
          ANO
          ASW
          BOT
          CCW
          CML
          CMP
          CMU
          CRD
          DEQ
          DEV
          DR
          DWI
          FAR
          FDL
          FEL
          FFR
          FLE
          FRA
          FTC
          FTY
          HOM
          IBK
          IP
          IT
          LDL
          LIC
          LTS
          MAJ
          MMV
          NAF
          NFX
          PUA
          PUN
          REF
          RKD
          SAF
          SCH
          SLV
          SPD
          SUS
          TMP
          WSR
        }
        autoViolations {
          AAF
          AFM
          ANC
          ANO
          ASW
          BOT
          CCW
          CML
          CMP
          CMPTV
          CMU
          CRD
          DEQ
          DEV
          DR
          DWI
          FAR
          FDL
          FEL
          FFR
          FLE
          FRA
          FTC
          FTY
          HOM
          IBK
          IP
          IT
          LDL
          LIC
          LTS
          MAJ
          MMV
          NAF
          NFX
          PUA
          PUN
          REF
          RKD
          SAF
          SCH
          SLV
          SPD
          SUS
          TMP
          UDR
          WSR
        }
      }
      removedDrivers {
        id
        pipEligible
        waivedPIPWL
        pipOptOut
        pipHasQHC
        postBindMVR
        addDate
        assignedCar
        userAssignedCar
        autoViolationDates
        communityDriveParticipation
        isPrimary
        isCoApplicant
        firstName
        middleName
        lastName
        suffix
        gender
        maritalStatus
        highestEducation
        driverStatus
        age
        dateOfBirth
        driversLicenseState
        driversLicenseNumber
        ageFirstLicensed
        relationshipToInsured
        fullTimeStudent
        goodStudent
        takenCourse
        courseDiscountConditionCheck
        excludeDriver
        schoolName
        schoolZip
        needSR22
        lapsedLicense
        exclusionReason
        removedReason
        removedBy
        removedTimestamp
        schoolLocation {
          address
          address2
          country
          city
          state
          zip
        }
        insuranceScore {
          homeTotal
          autoTotal
          total
        }
        insuranceScoreOverride
        insuranceScoreOverrideValue
        autoViolationsForUW {
          AAF
          AFM
          ANC
          ANO
          ASW
          BOT
          CCW
          CML
          CMP
          CMU
          CRD
          DEQ
          DEV
          DR
          DWI
          FAR
          FDL
          FEL
          FFR
          FLE
          FRA
          FTC
          FTY
          HOM
          IBK
          IP
          IT
          LDL
          LIC
          LTS
          MAJ
          MMV
          NAF
          NFX
          PUA
          PUN
          REF
          RKD
          SAF
          SCH
          SLV
          SPD
          SUS
          TMP
          WSR
        }
        autoViolations {
          AAF
          AFM
          ANC
          ANO
          ASW
          BOT
          CCW
          CML
          CMP
          CMPTV
          CMU
          CRD
          DEQ
          DEV
          DR
          DWI
          FAR
          FDL
          FEL
          FFR
          FLE
          FRA
          FTC
          FTY
          HOM
          IBK
          IP
          IT
          LDL
          LIC
          LTS
          MAJ
          MMV
          NAF
          NFX
          PUA
          PUN
          REF
          RKD
          SAF
          SCH
          SLV
          SPD
          SUS
          TMP
          UDR
          WSR
        }
      }
      buyUp {
        homeCoverage {
          coverageX {
            buyUps {
              value
              buyUp
            }
          }
        }
        rentersCoverage {
          coverageX {
            buyUps {
              value
              buyUp
            }
          }
        }
      }
      global {
        affinity
        affinityGroupStem
        rateControlDate
        employeeDiscount
        priorCancelNonPay
        fromRC1
        apiKeyFirst5
        troubleshootingMode
        ## home
        homeEffectiveDate
        homeownersPaymentType
        homeownersPaymentMethod
        personalPropertyProtection
        currentHomeownersCarrier
        currentHomeownersCarrierPolicyNumber
        homeBillingDayOfMonth
        homeMegaDownPay
        breakupWithHomeowners
        ## auto
        autoEffectiveDate
        discountInventoryScore
        discountPaperless
        discountBixMutualAffinity
        autoPaymentType
        autoPaymentMethod
        autoPaymentMode
        currentlyAutoInsured
        currentAutoCarrier
        currentAutoCarrierStartDate
        currentAutoCarrierEndDate
        currentAutoCarrierPolicyNumber
        currentAutoAMBEST
        continuousAutoCoverageStartDate
        mostRecentAutoInsuranceCoverageEndDate
        billingDayOfMonth
        autoBillingDayOfMonth
        homeSecurityPartnerCustomerType
        autoMegaDownPay
        breakupWithAuto
        isRC1PriorAutoCoverageDefaultsSet
        ## renters
        rentersEffectiveDate
        rentersPaymentType
        rentersPaymentMethod
        rentersBillingDayOfMonth
        currentRentersCarrier
        currentRentersCarrierPolicyNumber
        breakupWithRenters
        rentersMegaDownPay
        ## condo
        condoPaymentType
        condoPaymentMethod
        condoBillingDayOfMonth
        condoEffectiveDate
        condoMegaDownPay
        ## farm
        farmPaymentType
        farmPaymentMethod
        farmPaymentMode
        directBillPreferredPaymentMethod
        farmBillingDayOfMonth
        farmEffectiveDate
        farmMegaDownPay
        legacyDiscount
        militaryDiscount
        multiPolicyDiscount
        autoBundleCarrier
        educationDiscount
        traditionsDiscount
        farmAssociationDiscount
        cropInsuranceDiscount
        claimFreeDiscount
        memberOfCattlemenAssociation
        memberOfSoybeanAssociation
        ## cv data
        receivedCVData
        hadInforceCVPolicy
        priorIndividualBILimit
        priorOccurrenceBILimit
        priorUmIndividualBodilyInjury
        priorUmOccurrenceBodilyInjury
        priorDrivers {
          firstName
          lastName
        }
        priorCars {
          VIN
          year
          make
          model
          limitRental
          deductibleCollision
          deductibleComprehensive
          roadsideAssistance
        }
      }
      rentersCoverage {
        rentersLocation {
          address
          address2
          country
          city
          state
          zip
        }
        coverageCD
        coverageX
        coverageY
        deductible
      }
      umbrellaCoverage {
        numVehiclesTotal
        numLicensedDriversUnder25
        numMotorcyclesScooters
        numATVs
        numWatercraft
        numPersonalWatercraft
        watercraftHullLengths
        numRVs
        numRentalProperties
        numOtherProperties
        liabilityCoverageLimit
        limitBIOccurrence
        uninsuredMotoristLimit
        rentalPropertyAddresses {
          address
          address2
          country
          city
          state
          zip
        }
        otherPropertyAddresses {
          address
          address2
          country
          city
          state
          zip
        }
      }
      scheduledPersonalProperty {
        deductible
        items {
          category
          description
          value
          breakageOption
          exTheftOption
        }
      }
      earthquakeCoverage {
        policyId
      }
      floodCoverage {
        policyId
      }
      preBindUWCheck {
        homeVerification {
          signedPropertyUWAttestation
          ineligibleForHomeDueToUWSelfReport
          noAsbestosCheck
          homeWiringCheck
          homePlumbingCheck
          noOpenFoundationCheck
          # the below nodes are specific to the FL UW form
          hasTrampolinesOrSkateBoardRampEtc
          isMobileOrPrefabricatedEtc
          hadSinkholeActivityOrIsAdjacentToSinkholes
          isIneligibleDogBreed
          hasExoticOrNonDomesticatedEtcAnimals
          hasPetBiteHistoryOrViciousBehavior
          hasCommercialOccupation
          isOwnedByCorpOrPartnershipEtc
          hadRentedMultTimesOrFullTimeOneTenant
          isInForeclosure
          hasMoreThan2Mortgages
          runDayCareOutOfMyHome
          isPrimaryHome
          hadPriorLossIn5Years
          isWaterHeaterAgeGreaterThan15Years
          isPriorPolicyCancelledOrNonRenewed
          hasFlatRoofs
          excludeWindCoverage
          excludeContentCoverage
          includeSinkholeCoverage
          hasRecalledConstructionMaterials
          hasInsuranceCurrently
        }
        autoVerification {
          ineligibleForAutoDueToUWSelfReport
          signedPropertyUWAttestation
          # the below nodes are specific to the FL UW form
          needSR22
          excludeBICoverage
          # CFM auto UW questions (#32744)
          anyDriverLicenseSuspendedOrRevoked
          anyDriverLicenseSuspendedOrRevokedDetails
          anyDriverUnlistedRecentLoss
          anyDriverUnlistedRecentLossDetails
          anyDriverImpairingCondition
          anyDriverImpairingConditionDetails
          anyVehicleModifiedOrCustomized
          anyVehicleModifiedOrCustomizedDetails
          anyVehicleExistingDamage
          anyVehicleExistingDamageDetails
          anyVehicleUsedForHire
          anyVehicleUsedForHireDetails
          allVehiclesGaragedAtPolicyAddress
          allVehiclesGaragedAtPolicyAddressDetails
          hasUnlistedOrExcludedHouseholdDrivers
          hasUnlistedOrExcludedHouseholdDriversDetails
          signedAutoUWAttestation
        }
        farmVerification {
          unrepairedDamage
          unrepairedDamageDetails
          priorFireLoss
          priorFireLossDetails
          priorLiabilityLoss
          priorLiabilityLossDetails
          chargedWithFelony
          chargedWithFelonyDetails
          foreclosureBankruptcy
          foreclosureBankruptcyDetails
          coverageDeclined
          coverageDeclinedDetails
          otherInsuranceWithCompany
          otherInsuranceWithCompanyDetails
          otherResidences
          otherResidencesDetails
          dwellingsForSale
          dwellingsForSaleDetails
          unlistedStructures
          unlistedStructuresDetails
          recreationalVehicles
          recreationalVehiclesDetails
          livestockFencing
          livestockFencingDetails
          livestockEscape
          livestockEscapeDetails
          solarPanels
          solarPanelsDetails
          dogsOrExoticPets
          dogsOrExoticPetsDetails
          trampoline
          trampolineDetails
          dwellingsUnderRenovation
          dwellingsUnderRenovationDetails
          farmStructuresRentedToOthers
          farmStructuresRentedToOthersDetails
          commercialUseOfProperty
          commercialUseOfPropertyItems
          commercialUseOfPropertyOtherDetails
          commercialUseOfPropertyDetails
          businessConductedOnPremises
          businessConductedOnPremisesDetails
          dayCareBusiness
          dayCareBusinessDetails
          anhydrousAmmoniaEquipment
          anhydrousAmmoniaEquipmentDetails
          processOrManufacture
          processOrManufactureDetails
          huntingOrFishingFee
          huntingOrFishingFeeDetails
          customFarming
          customFarmingDetails
          namedInsuredIsPropertyOwner
          namedInsuredIsPropertyOwnerDetails
          # Policy restrictions
          restrictions
          # Change of Coverage — UW-only free-type notice trigger (#34275)
          changeOfCoverage
          # Attestation
          signedFarmUWAttestation
        }
        approvalDetails {
          sentToUnderwritingAt
          sentToUnderwritingBy
          underwriterApprovedAt
          underwriterApprovedBy
        }
        attestationAgent
      }
      overrides {
        canEditUneditablePropertyDetails
        allowExcludingDrivers
        rc1 {
          itemsChanged
          input {
            coverageA
          }
          calculated {
            rce
          }
          useCalculatedRce
        }
        overridesForUW {
          code
          overridingAgent
          type
        }
        overridesForFeFormValidation {
          skipBogusLoanNumberCheck
          skipUmbrellaBIPDValidation
        }
      }
      branchPlusPolicies {
        policyType
        policyCarrier
        policyNumber
        attestationAgent
      }
      ...FarmFragment
    }
    options {
      id
      name
      annual
      monthly
      type
      autoBill
      autoPremium
      autoTotal
      autoSchedule {
        date
        remainingMonthly
        transactionFee
        total
      }
      homeBill
      homeTotal
      homePremium
      homeSchedule {
        date
        remainingMonthly
        transactionFee
        total
      }
      rentersBill
      rentersTotal
      rentersPremium
      rentersSchedule {
        date
        remainingMonthly
        transactionFee
        total
      }
      condoBill
      condoTotal
      condoPremium
      condoSchedule {
        date
        remainingMonthly
        transactionFee
        total
      }
      farmBill
      farmPremium
      farmTotal
      farmSchedule {
        date
        remainingMonthly
        transactionFee
        total
      }
      homeFees {
        type
        description
        amount
      }
      autoFees {
        type
        description
        amount
      }
      rentersFees {
        type
        description
        amount
      }
      condoFees {
        type
        description
        amount
      }
      farmFees {
        type
        description
        amount
      }
      autoCoverages {
        type
        amount
        iteration
      }
      homeCoverages {
        type
        amount
      }
      rentersCoverages {
        type
        amount
      }
      condoCoverages {
        type
        amount
      }
      farmCoverages {
        type
        amount
        riskIndex
        sppIndex
      }
      alternateAutoOptionsByBIPD {
        bi {
          id
          value
        }
      }
      floodRates {
        options {
          deductible
          premium
          totalAmount
        }
        fees {
          amount
          type
        }
        caseLink
      }
      eqRates {
        options {
          deductible
          premium
          totalAmount
        }
        fees {
          amount
          type
        }
        caseLink
      }
      withMultiPolicyDiscount
      farmClarionDoorIds {
        liabilityClarionDoorId
        risksClarionDoorIds {
          riskId
          clarionDoorId
        }
      }
      clarionDoorRelease
    }
  }
  ${FARM_FRAGMENT}
`;

// Separate fragment for vendor data — restricted to TeamLeaders in the schema.
// Kept out of OFFER_FRAGMENT so non-TeamLeader queries don't trigger auth errors.
// https://github.com/gobranch/branch/issues/29244
export const VENDOR_DATA_FRAGMENT = gql`
  fragment VendorDataFragment on Offer {
    vendorData {
      carfax
      carfaxRecalls
      cape
      cherre
      attom
      corelogicResponses
      munichRe
      transunion {
        driverrisk {
          addOnProduct
          indicative {
            name
            dateOfBirth
            age
            address
            driversLicense {
              issuanceState
              type
              state
            }
          }
          error
        }
        credit {
          indicative {
            name
            dateOfBirth
            address
          }
          customCredit {
            trade
            collection
            inquiry
          }
          addOnProduct
          publicRecord
        }
      }
      verisk {
        cv {
          policies {
            policyNumber
            policyStatus
            inceptionDate
            lastReportedTermExpirationDate
            cancellationDate
            detail {
              subjects {
                givenName
                middleName
                surname
                nameSuffix
                dob
                gender
                maritalStatus
                dlState
                relationToPolicyHolder
                fromDate
                toDate
                secondarySourceInfo {
                  dob
                  gender
                  dlState
                  dlType
                  dlIssueDate
                  dlExpireDate
                }
              }
              vehicles
              coverages
              carrier
              mailingAddresses
            }
            history
          }
        }
        mvr
        mvrdata {
          statusCode
          motorVehicleReports {
            driver {
              name
              dob
              dlState
              license
              violations
            }
            status
          }
        }
        aplusauto {
          header
          claims {
            matchByInputDriverNumber
            lossInformation
            subjects {
              roleInClaim
              givenName
              surname
              dob
              dlState
              sequenceInInputDrivers
            }
            atFaultIndicator
            disputeStatement
          }
          antiFraudVerification
        }
        aplusproperty {
          header
          claims {
            claimType
            lossDate
            matchReason
            carrierName
            carrierClaimNumber
            dueToCatastrophe
            policy
            subjects {
              givenName
              surname
              dob
              dlState
              subjectType
              roleInClaim
            }
            addresses
            losses
          }
        }
        udi
        udidl {
          subjects {
            givenName
            surname
            dob
            gender
            maritalStatus
            age
            middleInitial
            secondarySourceInfo {
              dob
              gender
              dlState
              dlType
              dlIssueDate
              dlExpireDate
            }
          }
          addresses
          messages
        }
        threesixtyvalue
        threesixtyvalueResponses
        dtc
        fireline
        ppc
        ppcResponses
        roof
        vrr
      }
      corelogic {
        pxpoint
        foreclosure
      }
      gallagher {
        wildfire
      }
    }
  }
`;
